import {BaseClient} from '../utils/base-client';

class ExperimentsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    return workspaceId
      ? `api/app/workspaces/${workspaceId}/experiments/`
      : `api/app/projects/${projectId}/experiments/`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const experimentsClient = new ExperimentsClient();
